// extracted by mini-css-extract-plugin
module.exports = {"container":"app-collections_container__w2mzh","grid":"app-collections_grid__jJo1l"};